import { FC } from 'react';
import classNames from 'classnames';
import { CardLocation } from '#home/components/card-location/CardLocation';
import { SeoText } from '#home/components/SeoText';
import { SeoTextLong } from '#home/components/SeoTextLong';
import homeCss from '#srcCssModules/home/home.module.scss';
import homeTitleCss from '#srcCssModules/home/home-title.module.scss';
import homeContentCss from '#srcCssModules/home/home-content.module.scss';
import { CardPopularCityList } from '#home/components/card-popular-city-list';
import { useHomeContext } from '#home/hooks';
import { AdvertList } from '#home/components/advert-list';

const Content: FC = () => {
  const { seo, advertList } = useHomeContext();

  return (
    <div className={homeCss.home__content}>
      <div
        className={classNames(
          homeContentCss.homeContent__top,
          { [homeContentCss.homeContent__top_withFullHeight]: !advertList || advertList.length === 0 },
          { [homeContentCss.homeContent__top_withoutFullHeight]: advertList && advertList.length > 0 },
        )}
      >
        <h1 className={homeTitleCss.homeTitle}>
          {seo.h1}
        </h1>
        <SeoText />
        <CardLocation />
      </div>
      <div
        className={classNames(
          homeContentCss.homeContent__bottom,
          { [homeContentCss.homeContent__bottom_withGap5]: !advertList || advertList.length === 0 },
          { [homeContentCss.homeContent__bottom_withGap4]: advertList && advertList.length > 0 },
        )}
      >
        <AdvertList />
        <CardPopularCityList />
        <SeoTextLong />
      </div>
    </div>
  );
};

export { Content };
